import { posthogClient } from '../posthogClient'

export type IdentifyUserParams = {
    id: string
    email?: string
    name?: string
    roles?: string[]
    tenantId?: string
    tenantName?: string
    isProductAdmin?: boolean
}

export function identifyUser({
    id,
    email,
    name,
    roles,
    tenantId,
    tenantName,
    isProductAdmin,
}: IdentifyUserParams): void {
    if (!posthogClient) return

    const primaryRole = roles?.[0]

    posthogClient.identify(id, {
        email,
        name,
        role: primaryRole,
        roles,
        account_id: tenantId,
        tenant_id: tenantId,
        tenant_name: tenantName,
        is_product_admin: isProductAdmin,
    })
}

export function resetPosthogUser(): void {
    if (!posthogClient) return
    posthogClient.reset()
}
